import type {MicrositeRouteDefinition, MicrositeRoutePath} from './types';
import type {LanguageId} from '../translations/utils/languageManifest';

export const resolveLocalizedMicrositePath = (_languageId: LanguageId, routePath: MicrositeRoutePath) => routePath;

export const buildLocalizedMicrositeHref = (route: MicrositeRouteDefinition, languageId: LanguageId) => route.paths[languageId];
